module.exports = __webpack_public_path__ + "img/hx-jfycb.003f5b4d.svg";